import type { FC } from "react";
import { ChoiceChipGroup, type ChoiceChipOption } from "@visioni/a3s-ui/components";
import type { IsoWeekday } from "../../../client-messages";
import { ScheduleRow } from "../ScheduleRow";

export interface WeekdayFieldProps {
  readonly value: IsoWeekday;
  readonly onChange: (value: IsoWeekday) => void;
  readonly disabled?: boolean | undefined;
}

const LABEL = "Send on";

const OPTIONS: readonly ChoiceChipOption<IsoWeekday>[] = [
  { value: 1, label: "Mon", accessibilityLabel: "Monday" },
  { value: 2, label: "Tue", accessibilityLabel: "Tuesday" },
  { value: 3, label: "Wed", accessibilityLabel: "Wednesday" },
  { value: 4, label: "Thu", accessibilityLabel: "Thursday" },
  { value: 5, label: "Fri", accessibilityLabel: "Friday" },
  { value: 6, label: "Sat", accessibilityLabel: "Saturday" },
  { value: 7, label: "Sun", accessibilityLabel: "Sunday" },
];

/** The weekday a weekly report email is sent on. */
export const WeekdayField: FC<WeekdayFieldProps> = ({ value, onChange, disabled }) => (
  <ScheduleRow label={LABEL}>
    <ChoiceChipGroup
      options={OPTIONS}
      value={value}
      onChange={onChange}
      accessibilityLabel={LABEL}
      disabled={disabled}
    />
  </ScheduleRow>
);
